module.exports = __webpack_public_path__ + "img/four1Green.6cabb119.jpg";